import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.split-text-v1');

    elements.forEach(elem => {
        // Salva il contenuto originale
        const originalContent = elem.innerHTML;

        // Funzione per dividere il testo in righe
        function splitIntoLines(element, content) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
            const textNodes = Array.from(tempDiv.childNodes);
            const lines = [];
            let currentLine = '';

            const measureDiv = document.createElement('div');
            measureDiv.style.visibility = 'hidden';
            measureDiv.style.position = 'absolute';
            measureDiv.style.whiteSpace = 'nowrap';
            element.appendChild(measureDiv);

            textNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    const words = node.textContent.split(/(\s+)/);
                    words.forEach(word => {
                        measureDiv.textContent = currentLine + word;
                        if (measureDiv.offsetWidth > element.offsetWidth && currentLine) {
                            lines.push(currentLine.trim());
                            currentLine = word;
                        } else {
                            currentLine += word;
                        }
                    });
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    currentLine += node.outerHTML;
                }
            });

            if (currentLine) {
                lines.push(currentLine.trim());
            }

            element.removeChild(measureDiv);

            return lines;
        }

        // Dividi il testo in paragrafi
        const paragraphs = elem.innerHTML.split('</p>');

        // Svuota l'elemento
        elem.innerHTML = '';

        // Processa ogni paragrafo
        paragraphs.forEach((paragraph, index) => {
            if (paragraph.trim()) {
                const paragraphDiv = document.createElement('div');
                paragraphDiv.className = 'split-paragraph';
                
                // Dividi il paragrafo in righe mantenendo i tag HTML
                const lines = splitIntoLines(elem, paragraph + (index < paragraphs.length - 1 ? '</p>' : ''));

                // Crea gli elementi div per ogni riga
                lines.forEach(line => {
                    const lineDiv = document.createElement('div');
                    lineDiv.className = 'split-line';
                    lineDiv.innerHTML = line;
                    paragraphDiv.appendChild(lineDiv);
                });

                elem.appendChild(paragraphDiv);
            }
        });

        // Avvolgi ogni lettera in uno span e aggiungi la classe 'italic' se all'interno di <strong>
        elem.querySelectorAll('.split-line').forEach(line => {
            const originalHTML = line.innerHTML;
            let newHTML = '';
            let isInStrong = false;
            let isInTag = false;

            for (let i = 0; i < originalHTML.length; i++) {
                if (originalHTML[i] === '<') {
                    isInTag = true;
                    newHTML += originalHTML[i];
                } else if (originalHTML[i] === '>') {
                    isInTag = false;
                    newHTML += originalHTML[i];
                    if (originalHTML.substr(i - 7, 8) === '<strong>') {
                        isInStrong = true;
                    } else if (originalHTML.substr(i - 8, 9) === '</strong>') {
                        isInStrong = false;
                    }
                } else if (!isInTag && /\S/.test(originalHTML[i])) {
                    let spanClass = isInStrong ? 'letter italic' : 'letter';
                    newHTML += `<span class='${spanClass}'>${originalHTML[i]}</span>`;
                } else {
                    newHTML += originalHTML[i];
                }
            }

            line.innerHTML = newHTML;
        });

        // Seleziona tutte le linee create
        const lineElements = elem.querySelectorAll('.split-line');

        if (lineElements.length > 0) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: elem,
                    start: "top 90%",
                    end: "bottom 10%",
                    toggleActions: "play none none reverse",
                }
            });

            lineElements.forEach((line, index) => {
                const letters = line.querySelectorAll('.letter');
                
                tl.from(line, {
                    y: '100%',
                    opacity: 0,
                    duration: 1.5, // Aumentata la durata dell'animazione della riga
                    ease: 'power3.out',
                }, index * 0.3); // Aumentato il ritardo tra le righe

                tl.from(letters, {
                    y: '-100%',
                    opacity: 0,
                    scale: 0.5,
                    rotationX: 20,
                    transformOrigin: "0% 50% -50",
                    duration: 1.2, // Aumentata la durata dell'animazione delle lettere
                    ease: "back.out(1.7)",
                    stagger: {
                        amount: 1.2, // Aumentato lo stagger per un'animazione più lenta delle lettere
                        from: "start",
                    },
                }, "<0.2"); // Aggiunto un piccolo ritardo prima dell'animazione delle lettere
            });

        } else {
            console.warn('Nessuna riga trovata per:', elem);
            // Ripristina il contenuto originale se non sono state create righe
            elem.innerHTML = originalContent;
        }
    });
});
